import React, {Component} from 'react';

import {
	Button, Modal, ModalBody, ModalHeader, Form, FormGroup, Label, Input, InputGroup,
	InputGroupAddon, Tooltip, Row, Col, NavItem
} from 'reactstrap';
import ModalAlert from './ModalAlertComponent';
import {SignupVerificationModal} from './SignupVerificationModal';
import PasswordInputComponent from './PasswordInputComponent';
import { serverPath } from "./common";
import axios from 'axios';


class SignupModal extends Component
{
	constructor(props){
		super(props);
		this.state={
			isOpen : false,
			newUsernameClass: "",
			newEmailClass: "",
			usernameTooltipOpen: false,
			emailTooltipOpen: false,
			usernameTooltipText: "",
			emailTooltipText: "",
			modalAlertOpen: false,
			modalAlertMessage: "",
            verificationModalOpen: false,
            passwordValid : false,
			password : "",
		};
		this.checkEmail = this.checkEmail.bind(this);
		this.checkUsername = this.checkUsername.bind(this);
		this.closeEmailTooltip = this.closeEmailTooltip.bind(this);
		this.openEmailTooltip = this.openEmailTooltip.bind(this);
		this.closeUsernameTooltip = this.closeUsernameTooltip.bind(this);
		this.openUsernameTooltip = this.openUsernameTooltip.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.hideModalAlert = this.hideModalAlert.bind(this);
		this.hideVerificationModal = this.hideVerificationModal.bind(this);
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.onInvalidPassword = this.onInvalidPassword.bind(this);
		this.onValidPassword = this.onValidPassword.bind(this);
	}
/***********************************************HELPER MODALS FUNCTIONS***********************************************/
	showModalAlert(message) {
		this.setState({
			modalAlertMessage: message,
			modalAlertOpen: true
		});
	}

	hideModalAlert() {
		this.setState({
			modalAlertOpen: false,
			modalAlertMessage: ""
		});

	}
	showVerificationModal() {
		this.setState({
			verificationModalOpen: true
		});
	}

	hideVerificationModal() {
		this.setState({
			verificationModalOpen: false,
		});
	}
/**************************************************PASSWORD FUNCTIONS**************************************************/
	onInvalidPassword(){
		this.setState({
			passwordValid : false,
			password : "",
		})
	}
	onValidPassword(pass){
		this.setState({
			passwordValid : true,
			password : pass,
		})
	}
/**************************************************EMAIL FUNCTIONS**************************************************/
	checkEmail(_event) {
		const email = this.newEmail.value;
		const self = this;
		SignupModal.checkField("email", email)
			.then((resp) => {
				if(resp.data.valid === false){
					self.openEmailTooltip("Email nije validan!");
				}
				else if (resp.data.available === false) {
					self.openEmailTooltip("Email je zauzet!");
				}
				else if(resp.data.alasEmail === true){
					self.openEmailTooltip("Email je rezervisan za studente MATF-a");
				}
				else {
					self.closeEmailTooltip();
				}
			})
	}
/**************************************************USERNAME FUNCTIONS**************************************************/
	checkUsername(_event) {
		const username = this.newUsername.value.trim();
		const allAllowed = new RegExp('^[A-Za-z1-9_.-]+$');
		const atLeastOneLetter = new RegExp('[A-Za-z]');

		if(username.length <= 4){
			this.openUsernameTooltip("Korisničko ime mora imati više od 4 karaktera!");
		}
		else if(username.length > 15){
			this.openUsernameTooltip("Korisničko ime ne sme imati više od 15 karaktera!");
		}
		else if(atLeastOneLetter.test(username) === false){
			this.openUsernameTooltip("Korisničko ime mora sadržati slova!");
		}
		else if(username.match(allAllowed) === null){
			this.openUsernameTooltip("Dozvoljeni su brojevi, slova kao i karakteri -_.");
		}
		else{
			const self = this;
			SignupModal.checkField("avatar", username)
				.then((resp) => {
					if (resp.data.available === false) {
						self.openUsernameTooltip("Korisničko ime je zauzeto");
					}
					else if(resp.data.valid === false){
						self.openUsernameTooltip("Korisničko ime nije u ispravnom formatu!");
					}
					else if(resp.data.alasUsername === true){
						self.openUsernameTooltip("Korisničko ime rezervisano za studente MATF-a");
                    }
					else{
						self.closeUsernameTooltip();
					}	
				})
		}
	}
	static checkField(field, val) {
		const params = new URLSearchParams();
		params.append("fieldName", field);
		params.append("fieldValue", val);
		params.append("action", "fieldCheck");
		return axios.post(serverPath + "authService.php", params);
	}
/********************************************************TOOLTIP FUNCTIONS**************************************** */
	openUsernameTooltip(message) {
		this.setState({
			newUsernameClass: "border-danger",
			usernameTooltipOpen: true,
			usernameTooltipText: message,
		});
	}
	closeUsernameTooltip() {
		this.setState({
			newUsernameClass: "border-success",
			usernameTooltipOpen: false,
			usernameTooltipText: "",
		});
	}
	openEmailTooltip(message) {
		this.setState({
			newEmailClass: "border-danger",
			emailTooltipOpen: true,
			emailTooltipText: message,
		});
	}
	closeEmailTooltip() {
		this.setState({
			newEmailClass: "border-success",
			emailTooltipOpen: false,
			emailTooltipText: "",
		});
	}
/************************************************** SIGNUP FUNCTION************************************************* */
	async finalCheck(){

		if(!this.state.passwordValid){
			return Promise.reject(Error("Pass not valid"));
		}
		const waitEmail = this.checkEmail(null);
		const waitUser = this.checkUsername(null);
		await waitEmail;
		await waitUser;
	}
	handleSignup(_event) {
		const password = this.state.password;
		const username = this.newUsername.value;
		const self = this;
		this.finalCheck().then(()=>{
			const params = new URLSearchParams();
			params.append('username', username);
			params.append('email', this.newEmail.value);
			params.append('password', password);
			params.append("action", "signup");
			axios.post(serverPath + "authService.php", params)
				.then((response) => {
					if (response.data !== null) {
						if (response.data.success === false) {
							self.showModalAlert("Nije uspelo pravljenje naloga!\n" +
								"Proverite unete podatke i pokušajte ponovo!");
						}
						else {
							self.showVerificationModal();
							self.props.loginHandler(username, password);
							self.toggleModal();
						}
					}
				})
		});
	}

    componentWillReceiveProps(newProps) {
        this.setState({
            isOpen: newProps.isOpen
        });
	}
	/**when modal is closed it is not unmounted, therefore state stays the same
	 * this causes problem with tooltip(app crashes because tooltip is bound to id, when modal is
	 * closed id does not exist) and with ux(when modal is reopened border colors stay green/red)
	 */
	handleCloseModal(){
		this.setState({
			newUsernameClass: "",
			newEmailClass: "",
			usernameTooltipOpen: false,
			emailTooltipOpen: false,
			usernameTooltipText: "",
			emailTooltipText: "",
			modalAlertOpen: false,
			modalAlertMessage: ""
		})
	}
    toggleModal() {
        if(this.state.isOpen) {
			this.handleCloseModal();
        }
		this.setState({isOpen: !this.state.isOpen});
	}

	render(){
		return(
			<React.Fragment>
				<NavItem className="mx-1">
					<Button color="info" outline onClick={this.toggleModal}>
						<span className="fa fa-user-plus fa-lg"/> Napravi nalog
					</Button>
				</NavItem>

				<Modal isOpen={this.state.isOpen} toggle={this.toggleModal}>
					<ModalHeader toggle={this.toggleModal}>
						Napravi nalog
					</ModalHeader>
					<ModalBody>
						<Form>
							<FormGroup>
								<Label htmlFor="newUsername"> Korisničko ime </Label>
								<InputGroup>
									<InputGroupAddon addonType="prepend">
										<span className="input-group-text fa fa-user"/>
									</InputGroupAddon>
									<Input type="text" id="newUsername" name="newUsername"
										innerRef={(input) => { this.newUsername = input }}
										onBlur={this.checkUsername}
										className={this.state.newUsernameClass}
										autoComplete='off'/>
										
									<Tooltip target="newUsername"
										isOpen={this.state.usernameTooltipOpen}>
										{this.state.usernameTooltipText}
									</Tooltip>
								</InputGroup>
							</FormGroup>
							<FormGroup>
								<Label htmlFor="newEmail"> Email </Label>
								<InputGroup>
									<InputGroupAddon addonType="prepend">@</InputGroupAddon>
									<Input type="text" id="newEmail" name="newEmail"
										innerRef={(input) => { this.newEmail = input }}
										onBlur={this.checkEmail}
										className={this.state.newEmailClass}
										autoComplete='off'/>
									<Tooltip target="newEmail"
										isOpen={this.state.emailTooltipOpen}>
										{this.state.emailTooltipText}
									</Tooltip>
								</InputGroup>
							</FormGroup>
							<PasswordInputComponent onValidPassword={this.onValidPassword}
													onInvalidPassword={this.onInvalidPassword}/>
							<Row>
								<Col>
									<Button type="submit" color="primary"
											onClick={(event) => {
												this.handleSignup(event);
												event.preventDefault();
											}}>
										Napravi nalog
									</Button>
								</Col>
								<Col>
									<p style={{"font-size":"10px"}}>
										Napomena: Korisnici koji ovako naprave nalog imaju pristup samo algoritamskim zadacima
									</p>
								</Col>
							</Row>

						</Form>
					</ModalBody>
				</Modal>

				<ModalAlert showModal={this.state.modalAlertOpen} message={this.state.modalAlertMessage}
					closeModalHandler={this.hideModalAlert} />
				<SignupVerificationModal isOpen={this.state.verificationModalOpen} firstTime={true}
					closeModalHandler={this.hideVerificationModal}/>


			</React.Fragment>
		);
	}
}
export{SignupModal}